import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Situation } from 'types';
import SituationTable from '../../components/templates/situation-table';
import ButtonPrimary from '../../components/molecules/button-primary';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import {
  SituationsActions,
  UserInfoSelectors,
  SituationCategoryActions,
  SituationActions,
  SituationSelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import { StyledMainTitle, StyledListUtil } from '../../common/styling/mixins';
import history from '../../app-router/history';
import ModalContentConfirm from '../../components/organisms/modal-content-confirm';
import { isRequestError } from 'common/utils/error';
import MessageModal from '../../components/organisms/message-modal';

const { StyledListWrapper, StyledListTitleWrapper, StyledListButtonWrapper, StyledListBoldWrapper } = StyledListUtil;

const Situations: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const [situation, setSituation] = useState<Situation | undefined>(undefined);
  const [modalVisible, setModalVisible] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const canWriteSituations = useSelector(UserInfoSelectors.hasWriteAccess('Situations'));
  const error = useSelector(SituationSelectors.errorSelector);
  const errorType = useSelector(SituationSelectors.errorTypeSelector);

  useEffect(() => {
    dispatch(SituationsActions.fetchSituations());
    dispatch(SituationCategoryActions.fetchSituationCategory());
    dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Situation' }));
  }, [dispatch]);
  useEffect(() => {
    if (errorType && errorType === 'delete') setShowDeleteModal(true);
  }, [errorType]);

  const onDeleteHandler = (s: Situation): void => {
    setSituation(s);
    setModalVisible(true);
  };
  const onModalConfirm = (shouldRemove: boolean) => {
    if (shouldRemove && situation) {
      dispatch(SituationActions.deleteSituation(situation?.id.toString()));
    }
    setModalVisible(false);
  };
  const onClickCreateHandler = (): void => {
    history.push(`/situation`);
  };
  const onClickEditHandler = (s: Situation): void => {
    return history.push(`/situation/${s?.id}`);
  };
  return (
    <div>
      <Modal
        title={t('Modal', 'REASON_MODAL_TITLE')}
        footer={null}
        open={modalVisible}
        onCancel={() => onModalConfirm(false)}
      >
        <ModalContentConfirm
          title={
            <div>
              {t('Modal', 'SITUATION_DELETE_CONFIRM')}
              <StyledListBoldWrapper>{situation?.situationCategory?.name}</StyledListBoldWrapper>
              <StyledListBoldWrapper>{situation?.name}</StyledListBoldWrapper>
            </div>
          }
          onConfirm={onModalConfirm}
          warningMessage={t('Modal', 'WARNING_SITUATION')}
        />
      </Modal>

      <MessageModal
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Situation' }));
        }}
        errorMessage={error && isRequestError(error) ? undefined : error}
      />

      <Layout />
      <StyledListWrapper>
        <StyledListTitleWrapper>
          <StyledMainTitle>{t('SituationPage', 'SITUATION_REPOSITORY_PAGE_H21')}</StyledMainTitle>
          <StyledListButtonWrapper>
            {canWriteSituations && (
              <ButtonPrimary onClick={onClickCreateHandler}>{t('Buttons', 'ADD_SITUATION')}</ButtonPrimary>
            )}
          </StyledListButtonWrapper>
        </StyledListTitleWrapper>
        <SituationTable
          canWrite={canWriteSituations}
          onClickEdit={onClickEditHandler}
          onClickDelete={onDeleteHandler}
        />
      </StyledListWrapper>
    </div>
  );
};

export default Situations;
